/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Grid, Typography } from '@mui/material';
import {
  CheckCircleRounded as CheckCircleRoundedIcon,
} from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import { makeStyles } from 'tss-react/mui';

import PlaceMap from './other_components/PlaceMap';
import OrangeButton from '../buttons/Orange';
import {
  clientMessageByBookingStatus,
} from '../../shared_client_utils/bookingUtils';
import { myAppointmentsPath, newBookingUrl } from '../../client_routes';
import { OrangeInfoStrip } from '../InfoStrip';
import GreenButton from '../buttons/Green';
import HiveFootprint from '../HiveFootprint';

const useStyles = makeStyles()(theme => ({
  main: {
    [theme.breakpoints.up('sm')]: {
      overflowY: 'auto',
    },
  },
  content: {
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    padding: theme.spacing(3, 2, 2, 2),

    '& > div': {
      width: 'auto',
      marginBottom: '.5rem',
    },
  },
  checkIcon: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  bookingInfo: {
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '1rem !important',
    fontSize: theme.spacing(2),
    // color: '#ABABAB',
    color: grey[800],

    '& > div': {
      width: 'auto',
      padding: '1px 0'
    },
  },
  subscribedInfoStrip: {
    marginBottom: '1rem !important',
  },
  subscribedInfo: {
    fontSize: theme.spacing(7 / 4),
  },
  subscribedInfoTitle: {
    flex: 2,
    paddingRight: theme.spacing(2),
    width: 'auto',
  },
  subscribedInfoButtonBox: {
    alignItems: 'center',
    width: 'auto',
  },
  buttonBox: {
    marginBottom: '1rem !important',
  },
  returnToCustomerBox: {
    marginBottom: '1rem !important',
  },
  linkBox: {
    marginTop: theme.spacing(2),
  },
  link: {
    color: '#0091FF',
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
  footer: {
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2, 2, 10 / 8),
    backgroundColor: '#F2F2F2',
  },
}));

const Complete = (props) => {
  const {
    client,
    stepsData,
    isChangeAppointment,
    router,
    allowSubscription,
    hasClientJustSubscribed,
    handleSubscribeClient,
    classes: parentClasses,
    business: { bookingSettings, ...business },
    Link
  } = props;
  const { query: { token, fromId } } = router;

  const {classes, cx} = useStyles();

  const redirectOrReload = () => {
    if (isChangeAppointment && business) {
      window.location.href = newBookingUrl(business.slug)
    }

    return router.reload();
  }

  return (
    <div className={parentClasses.grid}>
      <PlaceMap
        lat={stepsData.location.lat}
        lng={stepsData.location.lng}
        className={parentClasses.mapOrNavigationBox}
        height="200px"
      />
      <main className={cx(parentClasses.main, classes.main)}>
        <Grid container className={classes.content}>
          <Grid item>
            <CheckCircleRoundedIcon
              color="secondary"
              className={classes.checkIcon}
            />
          </Grid>

          <Grid item>
            <Typography variant="h5">
              {
                isChangeAppointment ? (
                  `Your appointment has changed!`
                ) : (
                  `Thanks for booking, ${client.firstName}!`
                )
              }
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="subtitle1">
              {clientMessageByBookingStatus(bookingSettings.initialBookingStatus)}
            </Typography>
          </Grid>

          <Grid container className={classes.bookingInfo}>
            <Grid item>{stepsData.location.formattedAddress}</Grid>
            <Grid container>
              <Grid item>{stepsData.service.name}</Grid>
              {stepsData.staff.name && <Grid item>&nbsp;with {stepsData.staff.name}</Grid>}
            </Grid>
            <Grid container>
              <Grid item>{stepsData.datetime.formattedDate}</Grid>
              &nbsp;
              <Grid item className={classes.dateTimeDivider}>@&nbsp;</Grid>
              <Grid item>
                {stepsData.datetime.formattedStartTime}
                &nbsp;&mdash;&nbsp;
                {stepsData.datetime.formattedStopTime}
              </Grid>
            </Grid>
          </Grid>

          {allowSubscription && (
            <OrangeInfoStrip className={classes.subscribedInfoStrip}>
              <Grid container className={classes.subscribedInfo}>
                <Grid container className={classes.subscribedInfoTitle}>
                  Do you want to stay in the loop on promotions and discounts from {business.name}?
                </Grid>
                <Grid container className={classes.subscribedInfoButtonBox}>
                  {hasClientJustSubscribed ? (
                    <div>Thank you!</div>
                  ) : (
                    <GreenButton
                      variant="contained"
                      size="small"
                      onClick={handleSubscribeClient}
                    >
                      Subscribe
                    </GreenButton>
                  )}
                </Grid>
              </Grid>
            </OrangeInfoStrip>
          )}

          <Grid item className={classes.buttonBox}>
            <OrangeButton
              variant="contained"
              size="large"
              onClick={redirectOrReload}
            >
              Book another appointment
            </OrangeButton>
          </Grid>

          {isChangeAppointment && (
            <Grid item className={classes.returnToCustomerBox}>
              back to&nbsp;<Link href={myAppointmentsPath(token, fromId)}>
                <a className={classes.link}>my appointments</a>
              </Link>.
            </Grid>
          )}

          {business.website && (
            <Grid item className={classes.linkBox}>
              <a
                href={business.website}
                className={classes.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {business.website}
              </a>
            </Grid>
          )}
        </Grid>

        <Grid container className={classes.footer}>
          <HiveFootprint />
        </Grid>
      </main>
    </div>
  );
};

export default Complete;
